"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.14 247.63",
    children: [(0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M272.94,78.91l.2-.08-.28-.06A.64.64,0,0,1,272.94,78.91Z",
      transform: "translate(-8.88 -19.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "16px",
      d: "M184.24,200.5c2.91,3.11,5.76,6.27,8.65,9.41a10.87,10.87,0,0,1,2.75,5.08h0v.12a8.18,8.18,0,0,1,0,3,1,1,0,0,1-.09.49h0a10.64,10.64,0,0,1-2.91,5h0q-6.39,6.46-12.83,12.85l-.49.17h0a11,11,0,0,1-3.9,2.62h-.33a8.4,8.4,0,0,1-4.22.27h-.24a11,11,0,0,1-4.92-2.71h0l-9.25-8.45-1.25-1.14c-2.93-2.59-3.3-2.36-7.65-.41-2.39,1.08-4.85,2-7.29,3l-4.17,1.85-.18,2.56c-.31,5.41-.61,10.84-1.07,16.25a1.22,1.22,0,0,1,0,.27v.19a8.24,8.24,0,0,1-2,5,9.39,9.39,0,0,1-7.52,3.2h-19a9.39,9.39,0,0,1-7.52-3.2,8.41,8.41,0,0,1-2.14-5v-.27a1.22,1.22,0,0,0,0-.27c-.47-5.41-.74-10.84-1.08-16.25,0-.85-.09-1.71-.15-2.55l-4.18-1.86c-2.46-.95-4.9-1.95-7.3-3-4.36-1.95-4.73-2.18-7.66.41L75,228.25l-9.25,8.45h0a11,11,0,0,1-4.94,2.71h-.23a8.28,8.28,0,0,1-4.22-.27h-.31a10.88,10.88,0,0,1-3.91-2.61h0q-6.43-6.39-12.83-12.85h0a10.85,10.85,0,0,1-2.91-5h0a.92.92,0,0,0-.09-.49,8.23,8.23,0,0,1,0-3,.2.2,0,0,1,0-.11h0A10.56,10.56,0,0,1,39.1,210c2.87-3.14,5.74-6.3,8.63-9.41.82-.88,1.62-1.78,2.46-2.63a2.58,2.58,0,0,0,.39-3.48c-.07-.19-.16-.38-.25-.57-2-4.31-3.91-8.72-5.86-13.31a1.81,1.81,0,0,0-.86-.35l-4.82-.32-2.19-.11-2-.12-1.27-.1c-2.6-.15-5.21-.33-7.81-.56a11.77,11.77,0,0,1-1.19-.18,8.71,8.71,0,0,1-4.49-2,6.64,6.64,0,0,1-1.23-1.31h0l-.14-.2a9,9,0,0,1-1.64-4.84V149.72a8.15,8.15,0,0,1,2.36-5.7,9.18,9.18,0,0,1,6-2.77c2.34-.22,4.66-.39,7-.53l1.29-.1,2.59-.15h1.25l7-.41c2.31-5.22,4.57-10.19,6.68-15.25a2.87,2.87,0,0,0-.74-2.25c-3.61-4.06-7.32-8-11-12.06-4.19-4.59-4.13-9.76.2-14.08S47.93,88,52.18,83.75s9.49-4.39,14.08-.2c3.9,3.64,8,7.21,11.85,10.92a2.56,2.56,0,0,0,3.49.41c4.55-2.17,9.24-4.06,14.2-6.21V88h0c.31-4.71.58-9.55,1-14.41.1-1.58.18-3.19.4-4.75a4.21,4.21,0,0,1,.11-.6v-.16h0a8.69,8.69,0,0,1,8.42-6.87h20.69a8.7,8.7,0,0,1,8.4,6.87h0v.16c0,.2.07.4.1.6.23,1.56.29,3.17.39,4.75.39,4.86.64,9.76,1,14.41h0v.66m45.18,105.72",
      transform: "translate(-8.88 -19.5)"
    }), (0, jsx_runtime_1.jsx)("circle", {
      fill: "currentColor",
      cx: "106.14",
      cy: "140.93",
      r: "26.62"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M254.05,24.53a7.49,7.49,0,0,0-7.15-5H182.12a7.49,7.49,0,0,0-7.15,5l-27.49,82.52,14.31,4.45L187.6,34h53.82l25.81,77.47,14.31-4.45Z",
      transform: "translate(-8.88 -19.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M299.06,105.08a7.56,7.56,0,0,0-6.55-3.71h-156a7.39,7.39,0,0,0-7.51,7.28,7.12,7.12,0,0,0,1.09,3.77l31.48,49.88a7.56,7.56,0,0,0,6.41,3.48h9.12v36.06a7.39,7.39,0,0,0,7.51,7.26h59.8a7.39,7.39,0,0,0,7.51-7.26V165.78H261a7.59,7.59,0,0,0,6.42-3.48l31.47-49.88A7.07,7.07,0,0,0,299.06,105.08Zm-62.17,89.5H192.13v-28.8h44.76Zm19.93-43.33H172.2L149.9,115.9H279.12Z",
      transform: "translate(-8.88 -19.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M197.79,204.84l11.78,60.24H221.5l11.77-60.24Zm19.57,45.42h-4.27l-4.22-40.75h12.71Z",
      transform: "translate(-8.88 -19.5)"
    })]
  });
};

exports.default = Icon;